import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import {ReactComponent as LogoNight} from "../logo_night.svg";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const location = useLocation(); // Get current route

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav className='navbar bg-neutral-900'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo whitespace-nowrap' onClick={closeMobileMenu}>
            <LogoNight className='md:w-[8rem] w-[6rem] text-white'/>
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active bg-neutral-900' : 'nav-menu'}>
            <li className='nav-item'>
              <Link
                to='/'
                className={`nav-links ${isActive('/') ? 'active-tab' : ''}`}
                onClick={closeMobileMenu}
              >
                <p className='md:text-lg text-md text-white'>HOME</p>
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/projects'
                className={`nav-links ${isActive('/projects') ? 'active-tab' : ''}`}
                onClick={closeMobileMenu}
              >
                <p className='md:text-lg text-md text-white'>PROJECTS</p>
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/contact'
                className={`nav-links ${isActive('/contact') ? 'active-tab' : ''}`}
                onClick={closeMobileMenu}
              >
                <p className='md:text-lg text-md text-white'>ABOUT US</p>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
